import { MIN_LAUNCH_BUSINESS_DAYS } from "./launchDate";

/**
 * Minimum campaign lead time (in business days) is server-driven per country via
 * OADS settings — `countryDefaultSettings.defaultCampaignLimits`. The builder must
 * never hardcode it (this replaces the legacy `DM_MIN_SELECTABLE_DATE = 7`). The
 * H2H/D2D date picker, validation, and warning copy all consume this single source
 * so they reflect the configured value rather than a literal. See epic spec T3.
 */

// Used only when settings haven't loaded yet or a country has no value configured.
export const FALLBACK_MIN_LEAD_TIME_BUSINESS_DAYS = MIN_LAUNCH_BUSINESS_DAYS;

export const resolveMinLeadTimeBusinessDays = (defaultCampaignLimits: number | null | undefined): number => {
  if (
    typeof defaultCampaignLimits === "number" &&
    Number.isFinite(defaultCampaignLimits) &&
    defaultCampaignLimits > 0
  ) {
    return defaultCampaignLimits;
  }
  return FALLBACK_MIN_LEAD_TIME_BUSINESS_DAYS;
};

/**
 * Interpolate the configured lead time into copy containing the `{N}` token, so
 * validation/warning strings never embed a literal day count (AC16, AC28, AC35, AC36).
 */
export const interpolateLeadTime = (template: string, businessDays: number): string =>
  template.replace(/\{N\}/g, String(businessDays));
